import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]

  connect() {
    this.index = Date.now()
    this.beforeCacheHandler = () => this.removeHiddenCards()
    document.addEventListener("turbo:before-cache", this.beforeCacheHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)
  }

  add() {
    this.addWindow()
  }

  remove(event) {
    event.currentTarget.closest("[data-delivery-hours-card]")?.remove()
  }

  applyPreset(event) {
    const preset = event.currentTarget
    this.clearWindows()

    const days = (preset.dataset.days || "").split(",").filter(Boolean)
    days.forEach((day) => {
      this.addWindow(day, preset.dataset.start || "", preset.dataset.end || "")
    })
  }

  replace(event) {
    this.clearWindows()

    const deliveryWindows = event.detail?.deliveryWindows || []
    if (!deliveryWindows.length) {
      this.addWindow()
      return
    }

    deliveryWindows.forEach((deliveryWindow) => {
      this.addWindow(deliveryWindow.weekday, deliveryWindow.start_time, deliveryWindow.end_time)
    })
  }

  addWindow(day = "", startTime = "", endTime = "") {
    if (!this.hasListTarget || !this.hasTemplateTarget) return

    const wrapper = document.createElement("div")
    wrapper.innerHTML = this.templateTarget.innerHTML.replaceAll("__IDX__", this.index++)
    const card = wrapper.firstElementChild

    const weekdaySelect = card.querySelector("select")
    const startInput = card.querySelector('input[type="time"][name$="[start_time]"]')
    const endInput = card.querySelector('input[type="time"][name$="[end_time]"]')

    if (weekdaySelect) weekdaySelect.value = String(day)
    if (startInput) startInput.value = startTime
    if (endInput) endInput.value = endTime

    this.listTarget.appendChild(card)
  }

  clearWindows() {
    this.listTarget.querySelectorAll("[data-delivery-hours-card]").forEach((card) => {
      const destroyCheckbox = card.querySelector('input[type="checkbox"][name$="[_destroy]"]')
      if (destroyCheckbox) {
        destroyCheckbox.checked = true
        card.classList.add("d-none")
      } else {
        card.remove()
      }
    })
  }

  removeHiddenCards() {
    this.listTarget.querySelectorAll("[data-delivery-hours-card].d-none").forEach((card) => card.remove())
  }
}
